import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, Typography,
} from '@mui/material';
import styled from '@emotion/styled';
import { sendCustomNotification } from '../redux/ducks/notification';

const RecipientLabel = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
}));

const SubjectField = styled(TextField)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const SendNotificationDialog = ({ open, onClose, recipient }) => {
    const dispatch = useDispatch();
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [sending, setSending] = useState(false);

    const handleClose = () => {
        setSubject('');
        setBody('');
        onClose();
    };

    const handleSend = () => {
        if (!subject.trim() || !body.trim()) return;
        setSending(true);
        dispatch(sendCustomNotification(
            [recipient._id],
            subject.trim(),
            body.trim(),
            () => {
                setSending(false);
                handleClose();
            }
        ));
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Send Notification</DialogTitle>
            <DialogContent>
                <RecipientLabel variant="body2">
                    To: {recipient?.fullName}
                </RecipientLabel>
                <SubjectField
                    label="Subject"
                    value={subject}
                    onChange={e => setSubject(e.target.value)}
                    fullWidth
                    size="small"
                />
                <TextField
                    label="Message"
                    value={body}
                    onChange={e => setBody(e.target.value)}
                    fullWidth
                    multiline
                    rows={4}
                    size="small"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={sending}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSend}
                    disabled={sending || !subject.trim() || !body.trim()}
                >
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SendNotificationDialog;
